import React from 'react';

import { FormattedMessage } from '../../../util/reactIntl';
import ListYourItemsButton from '../ListYourItemsButton/ListYourItemsButton';
import css from './AlreadySelling.module.css';

// Shopping-bag glyph shown in the icon tile (from the design mockup).
const BagIcon = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M3 6h18" />
    <path d="M16 10a4 4 0 0 1-8 0" />
    <path d="m5 6 1 14a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-14" />
  </svg>
);

const CheckIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M20 6 9 17l-5-5" />
  </svg>
);

const ArrowIcon = () => (
  <svg
    className={css.ctaArrow}
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12h14" />
    <path d="m13 6 6 6-6 6" />
  </svg>
);

const REASSURANCES = [
  'CustomLandingPage.alreadySelling.chip.noObligation',
  'CustomLandingPage.alreadySelling.chip.noPenalty',
  'CustomLandingPage.alreadySelling.chip.noCatch',
];

// "Already selling on Vinted, eBay or Etsy?" — a new section reassuring sellers
// they can list on Causee alongside other marketplaces. Layout and colours follow
// the design mockup (MoreCausesv2.dc.html), rebuilt mobile-first.
const AlreadySelling = () => {
  return (
    <section className={css.section}>
      <div className={css.card}>
        <div className={css.iconTile} aria-hidden="true">
          <BagIcon />
        </div>

        <div className={css.content}>
          <h2 className={css.heading}>
            <FormattedMessage id="CustomLandingPage.alreadySelling.heading" />
          </h2>
          <h3 className={css.subheading}>
            <FormattedMessage id="CustomLandingPage.alreadySelling.subheading" />
          </h3>
          <p className={css.body}>
            <FormattedMessage id="CustomLandingPage.alreadySelling.body" />
          </p>

          <div className={css.chipRow}>
            {REASSURANCES.map(id => (
              <span className={css.chip} key={id}>
                <CheckIcon />
                <FormattedMessage id={id} />
              </span>
            ))}
          </div>

          <ListYourItemsButton linkClassName={css.ctaLink} buttonClassName={css.cta}>
            <FormattedMessage id="CustomLandingPage.alreadySelling.cta" />
            <ArrowIcon />
          </ListYourItemsButton>
        </div>
      </div>
    </section>
  );
};

export default AlreadySelling;
